interface ListingsCriteriaParams {
  [key: string]: any;
}

/**
 * Prepares the search parameters for the listings API call
 * Converts form data to the format the listings endpoint expects
 */
export function prepareSearchParams(formData: ListingsCriteriaParams): ListingsCriteriaParams {
  const searchParam = { ...formData };

  // Set defaults
  searchParam['MaxRows'] = '300';
  searchParam['publicid'] = searchParam?.publicid ? '' : '';

  // Capitalize the property type as required by the API (Residential, Commercial, Land, Multifamily)
  if (searchParam?.propertytype) {
    const type = searchParam.propertytype.toLowerCase();
    // Capitalize first letter: residential -> Residential
    searchParam['propertytype'] = type.charAt(0).toUpperCase() + type.slice(1);
  }

  // Convert boolean/checkbox values to expected format
  searchParam['golfcourse'] = searchParam?.golfcourse === 'yes' ? 'yes,Yes,y,Y,true,True,t,T' : '';
  searchParam['waterfront'] = searchParam?.waterfront === 'yes' ? 'yes,Yes,y,Y,true,True,t,T' : '';
  searchParam['propertyview'] = searchParam?.propertyview === 'yes' ? 'yes,Yes,y,Y,true,True,t,T' : '';
  searchParam['basement'] = searchParam?.basement === 'Y' ? 'yes,Yes,y,Y,true,True,t,T' : '';
  searchParam['carport'] = searchParam?.carport === 'Y' ? 'yes,Yes,y,Y,true,True,t,T' : '';
  searchParam['pool'] = searchParam?.pool === 'Y' ? 'yes,Yes,y,Y,true,True,t,T' : '';

  // Map property-type-specific fields (using lowercase for comparison)
  const propertyTypeLower = searchParam?.propertytype?.toLowerCase();
  switch(propertyTypeLower) {
    case 'residential':
      searchParam['res_golfcourse'] = searchParam?.golfcourse;
      searchParam['res_waterfront'] = searchParam?.waterfront;
      searchParam['res_propertyview'] = searchParam?.propertyview;
      searchParam['res_basement'] = searchParam?.basement;
      searchParam['res_carport'] = searchParam?.carport;
      searchParam['res_pool'] = searchParam?.pool;
      searchParam['res_previews'] = searchParam?.luxuryProperty;
      searchParam['res_featured'] = searchParam?.featuredProperty;
      break;
    case 'multifamily':
      searchParam['mul_propertyview'] = searchParam?.propertyview;
      searchParam['mul_waterfront'] = searchParam?.waterfront;
      searchParam['mul_golfcourse'] = searchParam?.golfcourse;
      break;
    case 'land':
      searchParam['lan_propertyview'] = searchParam?.propertyview;
      searchParam['lan_waterfront'] = searchParam?.waterfront;
      searchParam['lan_golfcourse'] = searchParam?.golfcourse;
      break;
  }

  return searchParam;
}
